import { createSlice } from "@reduxjs/toolkit";
import { createThunkCases } from "../util";
import { GetPaymentPlanDetailsThunk, InitiatePaymentThunk } from "./thunks";

const initialState = {
  loader: false,
  error: null,
  planDetails: [],
  displayModal: false,
  modalDetails: { title: "", type: 0, planDetails: {} },
  displayCompleteModal: false,
  completeModalDetails: { title: "", planDetails: {} },
  selectedModules: [5],
  customModuleDetails: {
    numberOfUsers: 1,
    calulatedPrice: 0,
  },
};

const PaymentSlice = createSlice({
  name: "PaymentGateway",
  initialState,
  reducers: {
    handleModal(state, action) {
      state.displayModal = action.payload;
    },

    handleModalDetails(state, action) {
      const { details, display } = action.payload;
      state.modalDetails = details;
      state.displayModal = display;
    },

    handleCompleteModal(state, action) {
      state.displayCompleteModal = action.payload;
    },

    handleCompleteModalDetails(state, action) {
      const { details, display } = action.payload;
      state.displayCompleteModal = display;
      state.completeModalDetails = details;
    },

    handleSelectedModules(state, action) {
      const { type, id } = action.payload;
      if (type === 1) {
        state.selectedModules.push(id);
      } else {
        state.selectedModules = state.selectedModules.filter((i) => i !== id);
      }
    },

    resetSelectedModules(state, action) {
      state.selectedModules = [5];
    },

    handleCustomModuleDetails(state, action) {
      state.customModuleDetails = action.payload;
    },
  },
  extraReducers(builder) {
    // GetPaymentPlanDetailsThunk
    createThunkCases(
      builder,
      GetPaymentPlanDetailsThunk,
      "Error Getting Subcription Plan Details.",
      (state, action) => {
        state.planDetails = action.payload;
      },
      null
    );

    // InitiatePaymentThunk
    createThunkCases(
      builder,
      InitiatePaymentThunk,
      "Error Initiating Payment.",
      null,
      null
    );
  },
});

export const {
  handleModal,
  handleModalDetails,
  handleSelectedModules,
  resetSelectedModules,
  handleCustomModuleDetails,
  handleCompleteModal,
  handleCompleteModalDetails,
} = PaymentSlice.actions;
export default PaymentSlice.reducer;
